/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Pit3_DInputs */

const en_diff_pit3_d = /** @type {(inputs: Diff_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparison stops as soon as two values are strictly equal, so a key present on both sides with the value null produces no output. If you are hunting for fields that are null when they should be populated, a diff against another document will not surface them. Use the viewer to inspect a single document for that.`)
};

const ko_diff_pit3_d = /** @type {(inputs: Diff_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 값이 완전히 같으면 비교가 바로 끝나므로, 양쪽에 값이 null인 키가 있으면 아무 출력도 나오지 않습니다. 채워져 있어야 하는데 null인 필드를 찾고 있다면 다른 문서와의 diff로는 드러나지 않습니다. 그 목적에는 뷰어로 단일 문서를 살펴보세요.`)
};

const ja_diff_pit3_d = /** @type {(inputs: Diff_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 つの値が完全に等しいと比較はすぐ終わるので、両側に値が null のキーがあると何も出力されません。埋まっているべきなのに null のフィールドを探しているなら、ほかの文書との差分では現れません。その用途にはビューアで単一の文書を調べてください。`)
};

/**
* | output |
* | --- |
* | "Comparison stops as soon as two values are strictly equal, so a key present on both sides with the value null produces no output. If you are hunting for fiel..." |
*
* @param {Diff_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_pit3_d = /** @type {((inputs?: Diff_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_pit3_d(inputs)
	if (locale === "ko") return ko_diff_pit3_d(inputs)
	return ja_diff_pit3_d(inputs)
});